import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { KpiCard, PageHeader, StatusPill } from "@/components/common";

export default function SupplierDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [rfqs, setRfqs] = useState([]);
  useEffect(() => {
    api.get("/stats").then(r => setStats(r.data));
    api.get("/rfqs").then(r => setRfqs(r.data.slice(0, 6)));
  }, []);
  return (
    <>
      <PageHeader
        title={`Hello, ${user?.full_name?.split(" ")[0] || "Supplier"}.`}
        subtitle="Qualified demand routed to your category. Quote fast, win more."
        actions={<Link to="/app/inbox" className="btn btn-primary" data-testid="open-inbox">Open RFQ inbox →</Link>}
      />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16, marginBottom: 28 }}>
        <KpiCard label="RFQ Inbox" value={stats?.inbox ?? "—"} accent="var(--amber-400)" />
        <KpiCard label="Quotes Sent" value={stats?.quotes_sent ?? "—"} />
        <KpiCard label="Won Deals" value={stats?.won_deals ?? "—"} />
        <KpiCard label="Win Rate" value={`${stats?.win_rate ?? 0}%`} />
        <KpiCard label="Revenue" value={`$${(stats?.revenue ?? 0).toLocaleString()}`} sub="CAD" />
      </div>
      <div className="card">
        <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--line)" }} className="font-mono">
          <span style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--ink-mute)" }}>LATEST MATCHED RFQs</span>
        </div>
        {rfqs.length === 0 ? <div style={{ padding: 32, textAlign: "center", color: "var(--ink-mute)" }}>No RFQs matched yet. Complete your category & regions in Company to improve matching.</div> : (
          <table className="data">
            <thead><tr><th>Code</th><th>Product</th><th>Qty</th><th>Region</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {rfqs.map(r => (
                <tr key={r.id}>
                  <td className="font-mono" style={{ color: "var(--amber-400)" }}>{r.code}</td>
                  <td>{r.product_name}</td>
                  <td>{r.quantity} {r.unit}</td>
                  <td>{r.delivery_region}</td>
                  <td><StatusPill status={r.status} /></td>
                  <td><Link to={`/app/rfqs/${r.id}`} className="btn btn-ghost" style={{ padding: "6px 12px", fontSize: 12 }}>Open</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
